<script setup>
// Composables
import useSessionActions from '~/composables/sessions/useSessionActions';

// Vars
const allowModal = ref(false);
const utilities = ref({});
const { $bus } = useNuxtApp();

onMounted(() => {
    $bus.on('toggleFavorite', (payload) => {
        const { session } = payload;
        if (!session) throw console.error('No session provided');
        allowModal.value = true;
        const {
            isFavorite,
            isFavoriteLoading,
            isSaveSeatLoading,
            activeModal,
            modalOpen,
            isReserved,
            toggleFavorite,
            handleSaveSeat,
            resetModal,
            doubleBookedSession,
            currentModalComponent,
            showRemoveFavoriteModal,
            showConfirmRemoveFavoritesModal,
            showRemoveFavoritesRemoveSeatModal,
        } = useSessionActions(session);

        utilities.value = {
            session,
            isFavorite,
            isFavoriteLoading,
            isSaveSeatLoading,
            activeModal,
            modalOpen,
            isReserved,
            toggleFavorite,
            handleSaveSeat,
            resetModal,
            doubleBookedSession,
            currentModalComponent,
            showRemoveFavoriteModal,
            showConfirmRemoveFavoritesModal,
            showRemoveFavoritesRemoveSeatModal,
        };

        $bus.emit('firedToggleFavorite', { session });
        payload.isFavoriteLoading.value = true;
        utilities.value.toggleFavorite(payload.isFavoriteLoading);
    });

    $bus.on('handleSaveSeat', (payload) => {
        const { session } = payload;
        if (!session) throw console.error('No session provided');
        allowModal.value = true;

        const {
            isFavorite,
            isFavoriteLoading,
            isSaveSeatLoading,
            activeModal,
            modalOpen,
            isReserved,
            toggleFavorite,
            handleSaveSeat,
            resetModal,
            doubleBookedSession,
            currentModalComponent,
            showRemoveFavoriteModal,
            showConfirmRemoveFavoritesModal,
            showRemoveFavoritesRemoveSeatModal,
        } = useSessionActions(session);

        utilities.value = {
            session,
            isFavorite,
            isFavoriteLoading,
            isSaveSeatLoading,
            activeModal,
            modalOpen,
            isReserved,
            toggleFavorite,
            handleSaveSeat,
            resetModal,
            doubleBookedSession,
            currentModalComponent,
            showRemoveFavoriteModal,
            showConfirmRemoveFavoritesModal,
            showRemoveFavoritesRemoveSeatModal,
        };

        $bus.emit('firedHandleSaveSeat', { session });
        if (payload.isSaveSeatLoading) {
            payload.isSaveSeatLoading.value = true;
        }
        utilities.value.handleSaveSeat(session, payload?.isSaveSeatLoading || isSaveSeatLoading, payload.holdOpen);
    });
});

onBeforeUnmount(() => {
    $bus.off('toggleFavorite');
    $bus.off('handleSaveSeat');
});
</script>

<template>
    <ProjectModal v-if="allowModal && utilities.activeModal" :opened="utilities.modalOpen" :closeInside="true"
        @close="utilities.resetModal" classes="inner-close">
        <component :is="utilities.currentModalComponent" :session="utilities.session"
            :doubleBookedSession="utilities.doubleBookedSession"
            @showRemoveFavoriteModal="utilities.showRemoveFavoriteModal"
            @showConfirmRemoveFavoritesModal="utilities.showConfirmRemoveFavoritesModal"
            @showRemoveFavoritesRemoveSeatModal="utilities.showRemoveFavoritesRemoveSeatModal"
            @close="utilities.resetModal" />
    </ProjectModal>
</template>
